module.exports = __webpack_public_path__ + "static/media/wheat.b9a05e35.svg";